const config = {
  api: process.env.REACT_APP_API_URL
}

export default config
